<template>
  <div class="login-bar">
    <p><input type="text" placeholder="EMAIL ADDRESS" v-model="user.user" /></p>
    <p><input type="password" placeholder="PASSWORD" v-model="user.password" /></p>
    <p><button @click="signIn(user)">SIGN IN</button></p>
  </div>
</template>

<script>
export default {
  name: 'LoginBar',
  data: () => ({
    user: {
      user: null,
      password: null
    }
  }),
  async mounted () {
    this.user.user = process.env.VUE_APP_USER || null
    this.user.password = process.env.VUE_APP_PASS || null
  }
}
</script>

<style>

</style>